export default "__VITE_ASSET__BE1nKSqi__"